import { ReactNode, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Stack, SegmentedControl, SegmentedControlItem, Container } from '@optimus-web/core';
import { clearSearchResults, resetSearch } from '../../../../search/actions';
import { Section } from './enum';
import { ItemAssignmentDialogContentOwnProps } from './types';

interface SectionProps<T> {
    [Section.Current]: T;
    [Section.Search]: T;
    [Section.Another]: T;
}

type OwnProps = Omit<ItemAssignmentDialogContentOwnProps, 'billId' | 'accountIds' | 'billingMode'> & {
    sections: SectionProps<ReactNode>;
    labels: SectionProps<ReactNode>;
    dataTestIds: SectionProps<string>;
};

const isSection = (value: string): value is Section => Object.values<string>(Section).includes(value);

export const ItemAssignmentDialogContentSwitch = ({ scope, dataTestIds, labels, sections }: OwnProps) => {
    const dispatch = useDispatch();
    const [selectedSection, setSelectedSection] = useState(Section.Current);

    const getItemProps = (section: Section) => {
        const sectionDataTestId = dataTestIds[section];

        return {
            [sectionDataTestId]: true,
            label: labels[section],
            value: section,
            name: 'section',
        };
    };

    return (
        <Stack vertical spacing="200">
            <SegmentedControl
                value={selectedSection}
                onChange={(_, val) => {
                    dispatch(clearSearchResults(scope));
                    dispatch(resetSearch(scope));
                    if (isSection(val)) setSelectedSection(val);
                }}
            >
                <SegmentedControlItem {...getItemProps(Section.Current)} />
                <SegmentedControlItem {...getItemProps(Section.Search)} />
                <SegmentedControlItem {...getItemProps(Section.Another)} />
            </SegmentedControl>
            {sections[selectedSection]}
            <Container padding={['100', '0']} />
        </Stack>
    );
};
